import { RouteRecordRaw } from 'vue-router';
import { ROUTER_NAME_WORKBENCH, ROUTER_PATH_WORKBENCH } from './workbench-app.constant';
import WorkbenchApp from './workbench-app.vue';

export const workbenchAppRouter: RouteRecordRaw[] = [
  {
    path: ROUTER_PATH_WORKBENCH,
    name: ROUTER_NAME_WORKBENCH,
    component: WorkbenchApp,
  },
];
